import { gql } from '@apollo/client';

export const GET_CAMPAIGN_PROPERTIES_FOR_CAMPAIGN = gql`
    query ($campaignId: MultiTypeInput!) {
        table(
            name: "campaign_property"
            filter: [{ left: "campaign_id", right: $campaignId, expression: "=" }]
            limit: 50
        )
    }
`;

export const CREATE_CAMPAIGN_PROPERTIES = gql`
    mutation ($rows: [GraphQLCreateRows]) {
        batchCreateRow(table: "campaign_property", rows: $rows)
    }
`;

export const DELETE_CAMPAIGN_PROPERTIES = gql`
    mutation ($ids: [String]) {
        batchDeleteRow(table: "campaign_property", ids: $ids)
    }
`;
